import "./posts.css";
import Post from "../post/Post";

function Posts() {
    return (
        <>
            <section className="blog__posts">
                <Post />
                <Post />
                <Post />
                <Post />
                <Post />
                <Post />
                <Post />
                <Post />
                <Post />
            </section>
        </>
    );
}

export default Posts;
